// Application Modal IDs
export const NEW_GROUP_MODAL_ID = "new-group-modal";
export const CUSTOM_GROUP_MODAL_ID = "custom-group-modal";
export const NEW_EVENT_MODAL_ID = "new-event-modal";
export const NEW_DM_MODAL_ID = "new-dm-modal";
export const NEW_SUBCHAT_MODAL_ID = "new-subchat-modal";
